// React Dependencies
import React, { useState } from 'react';

// External Dependencies
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import moment from 'moment';

// Internal Dependencies
import OverLoading from '../../../../../components/Loading';
import MText from '../../../../../components/Common/MText';
import MButton from '../../../../../components/MButton';
import Colours from '../../../../../styles/colours';
import ApiService from '../../../../../services/apiService';
import { Status } from '../../../../../common/constants';
import { IsEmpty } from '../../../../../common/checks';
import { VoucherActionType } from '../constants';

const ActionModal = (props) => {
  const [isLoading, setIsLoading] = useState(false);

  const onConfirmAction = async () => {
    try {
      setIsLoading(true);

      const dataToUpdate = {
        ...props.selectedVoucher,
        id:               undefined, // remove the value from update data
        balQty:           undefined, // remove the value from update data
        minSpend:         props.selectedVoucher.minSpend || 0,
        expiryDate:       props.selectedVoucher.expiryDate ? moment(props.selectedVoucher.expiryDate).utcOffset('+08').endOf('day').format() : null,
        validityInMonths: props.selectedVoucher.validityInMonths ? Number(props.selectedVoucher.validityInMonths) : null,
        issuableQty:      IsEmpty(props.selectedVoucher.issuableQty) ? null : props.selectedVoucher.issuableQty,
      };

      if (props.type === VoucherActionType.Delete) {
        await ApiService.deleteLoyaltyCardGift({
          giftId:        props.selectedVoucher.id,
          loyaltyCardId: props.loyaltyCardId,
          pageId:        props.pageId,
        });
      } else if (props.type === VoucherActionType.Deactivate) {
        await ApiService.updateLoyaltyCardGift({
          giftId:        props.selectedVoucher.id,
          loyaltyCardId: props.loyaltyCardId,
          pageId:        props.pageId,
        }, {
          ...dataToUpdate,
          status: Status.Deactivated,
        });
      } else if (props.type === VoucherActionType.Activate) {
        await ApiService.updateLoyaltyCardGift({
          giftId:        props.selectedVoucher.id,
          loyaltyCardId: props.loyaltyCardId,
          pageId:        props.pageId,
        }, {
          ...dataToUpdate,
          status: Status.Activated,
        });
      } else {
        return;
      }

      props.onComplete();
      props.onClose();

      toast.success(`Voucher ${props.type.toLowerCase()}d successfully`);
    } catch (error) {
      toast.error(error?.message || `Failed to ${props.type.toLowerCase()} voucher`);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog
      open={props.open}
      fullWidth
    >
      <DialogTitle>
        <MText size={14} text={`${props.type} Confirmation`} />
      </DialogTitle>
      <Box position="absolute" top={0} right={0}>
        <IconButton onClick={props.onClose}>
          <Close />
        </IconButton>
      </Box>

      { isLoading && <OverLoading /> }

      <DialogContent>
        <MText size={13} bold>
          The voucher will be
          {' '}
          {props.type}
          d. This action cannot be undone.
        </MText>
      </DialogContent>

      <DialogActions className="pb-4 pr-3">
        <MButton onClick={props.onClose} text="Cancel" variant="outlined" />
        <MButton
          className="ml-4"
          onClick={onConfirmAction}
          text={props.type}
          textColour={Colours.White}
          variant="outlined"
          colour={Colours.Secondary}
        />
      </DialogActions>
    </Dialog>
  );
};

ActionModal.defaultProps = {
  type:            VoucherActionType.Delete,
  selectedVoucher: {},
};

ActionModal.propTypes = {
  pageId:          PropTypes.number.isRequired,
  loyaltyCardId:   PropTypes.number.isRequired,
  open:            PropTypes.bool.isRequired,
  onClose:         PropTypes.func.isRequired,
  onComplete:      PropTypes.func.isRequired,
  type:            PropTypes.oneOf([VoucherActionType.Delete, VoucherActionType.Activate, VoucherActionType.Deactivate]),
  selectedVoucher: PropTypes.shape({
    id:               PropTypes.string,
    minSpend:         PropTypes.number,
    expiryDate:       PropTypes.string,
    validityInMonths: PropTypes.number,
    issuableQty:      PropTypes.number,
  }),
};
export default ActionModal;
